window.$ = window.jQuery = require('jquery');

$(document).ready(function () {
    require('./modules/calculator-vds');
    require('./modules/calculator-backup');

    /*
    @see https://www.vultr.com/
    $(".button:not(.no-hover-effect)").each(function () {
        let h = $("<span/>").addClass('btn-hover-effect');
        $(this).append(h).mousemove(function (t) {
            let e = t.currentTarget.getBoundingClientRect();
            let s = t.clientX - e.left, a = t.clientY - e.top;
            $(h).css({left: s, top: a});
        });
    });
    */

    require('./modules/slider-top');

    // Events
    require('./modules/goals-tracker');

    // Visible
    require('./modules/assembly-icons');
    require('./modules/faq-questions');

    // Rorms
    require('./modules/form-inline');
    require('./modules/modals-open');

    // Effects
    require('./modules/clone-effect');
    require('./modules/form-modal');

    // Other
    require('./modules/counterup');

    // Slick
    require('./modules/customers-slick');
    require('./modules/letters-slick');
    require('./modules/case-slick');

    require('./modules/widget-support');
    require('./modules/mobile-menu');
    require('./modules/assemblies-slick')
    require('./modules/wowjs')
});
